import React from 'react';
import StaticLayoutInner from '@/layouts/StaticLayoutInner';

const NoProjects = () => {
	return (
		<StaticLayoutInner centerContent>
			<div className="flex flex-col items-center justify-center text-center mx-auto">
				<>
					<h1 className="text-[40px] md:text-[5.5rem] font-semibold text-brand-green mt-2 mb-[22px] md:mb-8 font-founders tracking-normal leading-[0.9] md:text-center max-w-[29rem] md:max-w-[35rem] mx-auto">
						You don't have any projects yet...
					</h1>
					<div>Please create your first project in our Telegram bot.</div>
					{/*TODO Check url */}
					<a className="btn-primary text-lg py-3 px-16 h-auto mt-4"
						 href="https://t.me/InviteMemberBot?start=new_project"
						 target="_blank"
						 rel="noopener noreferrer"
					>
						Create Project
					</a>
				</>
				<div className="relative flex flex-col lg:flex-row w-full justify-center items-center">
					<div className="flex justify-center gap-6 lg:gap-8 pt-6 lg:pt-10 pb-4 lg:pb-14 text-sm lg:text-base leading-[16.8px] lg:leading-[19.2px] font-normal">
						<a href="https://invitemember.com/terms"
						   target="_blank"
						   rel="noopener noreferrer"
						   className="text-[13px]/[1.4] text-[#A5A5A5] hover:underline">
							Terms of Service
						</a>
						<a href="https://invitemember.com/privacy"
						   target="_blank"
						   rel="noopener noreferrer"
						   className="text-[13px]/[1.4] text-[#A5A5A5] hover:underline">
							Privacy Policy
						</a>
					</div>
				</div>
			</div>
		</StaticLayoutInner>
	);
};

export default NoProjects;
